<template>
    <div>
        <vs-table search stripe border description :sst="true" :data="table.data" :max-items="table.length"
            :total="table.total" @search="handleSearch" @change-page="handleChangePage" @sort="handleSort">
            <template slot="header">
                <vs-dropdown vs-trigger-click class="cursor-pointer">
                    <div
                        class="flex items-center justify-between p-3 font-medium border border-solid rounded-full cursor-pointer d-theme-border-grey-light d-theme-dark-bg">
                        <span class="mr-2">{{ this.table.start }} - {{ this.table.end }} of
                            {{ this.table.total }}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>
                    <vs-dropdown-menu>
                        <vs-dropdown-item v-for="item in table.limits" :key="item" @click="handleChangelength(item)">
                            <span>{{ item }}</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
                <vs-button v-if="sku_codes.length > 0" color="success" @click="handleConfirm(null, 'multiple')" class="ml-2">Execute ({{ sku_codes.join(", ") }})</vs-button>
                <vs-button v-else color="success" @click="handleConfirm(null, 'multiple')" class="ml-2">Execute</vs-button>
            </template>
            <template slot="thead">
                <vs-th>Select</vs-th>
                <vs-th>Warehouse</vs-th>
                <vs-th>Item</vs-th>
                <vs-th>Date</vs-th>
                <vs-th>Map</vs-th>
                <vs-th>Stock</vs-th>
                <vs-th>Value</vs-th>
                <vs-th>Var Close Value</vs-th>
                <vs-th>Action</vs-th>
            </template>
            <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        <vs-checkbox class="mx-auto" v-model="tr.checked" @click="handleCheck(tr)"></vs-checkbox>
                    </vs-td>
                    <vs-td>{{ tr.warehouse_code }} - {{ tr.warehouse_name }}</vs-td>
                    <vs-td>{{ tr.sku_code }} - {{ tr.item_name }} <br> Unit : {{ tr.unit }}</vs-td>
                    <vs-td>Start Date: {{ formatDate(tr.start_date) }} <br> End Date: {{ formatDate(tr.end_date) }}</vs-td>
                    <vs-td>Map Close: {{ tr.map_close }} <br> Map Recalculate: {{ tr.map_recalculate }}</vs-td>
                    <vs-td>
                        Open Stock: {{ tr.open_stock }} <br>
                        Receipt Stock: {{ tr.receipt_stock }} <br>
                        Issue Stock: {{ tr.issue_stock }} <br>
                        Close Stock: {{ tr.close_stock }} <br>
                    </vs-td>
                    <vs-td>
                        Open Value: {{ tr.open_value }} <br>
                        Receipt Value: {{ tr.receipt_value }} <br>
                        Issue Value: {{ tr.issue_value }} <br>
                        Close Value: {{ tr.close_value }} <br>
                        Close Value Recalculate: {{ tr.close_value_recalculate }} <br>
                        Adjustment Value: {{ tr.adjustment_value }} <br>
                        Ad Val: {{ tr.ad_val }} <br>
                        Open Val: {{ tr.open_val }} <br>
                    </vs-td>
                    <vs-td>{{ tr.var_close_value }}</vs-td>
                    <vs-td>
                        <div class="flex vx-input-group">
                            <vs-button size="small" color="success" icon-pack="feather" icon="icon-check" title="Execute"
                                style="margin-right: 2px" @click="handleConfirm(tr, 'single')" />
                        </div>
                    </vs-td>
                    
                </vs-tr>
            </template>
        </vs-table>
        <vs-pagination style="padding-top: 5px" :total="table.totalPage" v-model="setPage" />
    </div>
</template>
<script>
import { forEach } from "lodash";
import moment from "moment";
export default {
    components: {},
    props: {
        draw: {
            type: Number,
        },
        whCode: {
            type: String,
        },
        whId: {
            type: Number,
        },
    },
    data() {
        return {
            deleteId: null,
            table: this.tableDefaultState(),
            checkedAll: false,
            checked: [],
            selectedRouteAssignmentToAssign: [],
            timeOuts: null,
            totalExcec: 0,
            sku_codes: [],
            params: [],
        };
    },
    methods: {
        tableDefaultState() {
            return {
                data: [],
                length: 5,
                page: 1,
                search: "",
                order: "",
                sort: "desc",
                total: 0,
                totalPage: 1,
                totalSearch: 0,
                limits: [5, 10, 25, 50, 100, 1000],
                start: 1,
                end: 0,
            };
        },
        handleSearch(searching) {
            this.table.search = searching;
            this.table.page = 1;
            if (this.timeOuts) { clearTimeout(this.timeOuts) }
            this.timeOuts = setTimeout(this.getData, 900);
        },
        handleChangePage(page) {
            this.table.page = page;
            this.getData();
        },
        handleSort(key, active) {
            this.table.order = key;
            this.table.sort = active;
            this.getData();
        },
        handleChangelength(val) {
            this.table.length = val == "All" ? this.table.total : val;
            this.table.page = 1;
            this.getData();
        },
        getData() {
            console.log(this.whCode)
            console.log(this.whId)
            if (this.whId != 0 && this.whCode != "") {
                this.$vs.loading();
                this.$http
                .get("/api/wms/v1/map-revaluation/get", {
                    params: {
                        length: this.table.length,
                        page: this.table.page,
                        search: this.table.search,
                        order: this.table.order,
                        sort: this.table.sort,
                        wh_code: this.whCode,
                        wh_id: this.whId,
                    },
                })
                .then((resp) => {
                    if (resp.code == 200) {
                        this.table.total = resp.data.total_record;
                        this.table.totalPage = resp.data.total_page;
                        this.table.totalSearch = resp.data.total_record_search;
                        this.table.length = resp.data.total_record_per_page;
                        this.table.data = resp.data.records
                        this.setStartEnd();
                        this.$vs.loading.close();
                    } else {
                        this.$vs.loading.close();
                    }
                });
            }
        },
        setStartEnd() {
            let valStart =
                this.table.length * this.table.page - this.table.length + 1;

            if (valStart > this.table.total) {
                valStart = 1;
            }
            if (this.table.total == 0) {
                valStart = 0;
            }
            let valEnd = this.table.length * this.table.page;

            if (valEnd > this.table.total) {
                valEnd = this.table.total;
            }

            if (
                this.table.totalSearch < this.table.total &&
                this.table.search != ""
            ) {
                valEnd = this.table.totalSearch;
            }

            this.table.start = valStart;
            this.table.end = valEnd;
        },
        handleCreate(id, wh, sku) {
            this.$router.push({
                name: "map-revaluation-create",
                query: {wh: wh, sku: sku, id: id},
            });
        },
        handleConfirm(data, status) {
            if (status == "single") {
                this.sku_codes = [data.sku_code];
                this.params = [{
                    wh_id: data.warehouse_id,
                    sku_code: data.sku_code,
                    wh_code: data.warehouse_code,
                    map_close: data.map_close,
                    map_recalculate: data.map_recalculate,
                }];
                this.totalExcec = 1;
            }
            console.log(this.params)
            this.$vs.dialog({
                type: "confirm",
                title: `Confirm`,
                text: "Are you sure to execute this data ? You have selected " + this.totalExcec + " SKU",
                accept: () => {
                    this.$vs.loading();
                    this.$http.post(`/api/wms/v1/map-revaluation/execute`, this.params)
                    .then((resp) => {
                        this.$vs.loading.close();
                        if (resp.code == 200) {
                            this.$vs.dialog({
                                color: "success",
                                title: "Excuted",
                                text: resp.message,
                            });
                            console.log("execute")
                            console.log(this.params)
                        } else {
                            this.$vs.dialog({
                                color: "danger",
                                title: "Something went wrong",
                                text: resp.message,
                            });
                        }
                    })
                    .catch(error => {
                        this.$vs.loading.close();
                        this.$vs.dialog({
                            color: "danger",
                            title: "Error",
                            text: error,
                        })
                        .finally(() => {
                            this.sku_codes = [];
                            this.params = [];
                            this.totalExcec = 0;
                            this.getData();
                        });
                    });
                },
                cancel: () => {
                    for (let i = 0; i < this.sku_codes.length; i++) {
                        this.table.data[i].checked = false;
                    }
                    this.sku_codes = [];
                    this.params = [];
                    this.totalExcec = 0;
                }
            });
        },
        handleCheck(data) {
            if (this.sku_codes.indexOf(data.sku_code) == -1) {
                this.sku_codes.push(data.sku_code);
                this.params.push({
                    wh_id: data.warehouse_id,
                    sku_code: data.sku_code,
                    wh_code: data.warehouse_code,
                    map_close: data.map_close,
                    map_recalculate: data.map_recalculate,
                });
            } else {
                let idx = this.sku_codes.indexOf(data.sku_code)
                this.sku_codes.splice(idx, 1);
                this.params.splice(idx, 1);
            }
            this.totalExcec = this.sku_codes.length;
        },
        // utcToLocal(val) {
        //     if (val) {
        //         return moment(val)
        //             .add(-7, "h")
        //             .utc()
        //             .local()
        //             .format("DD MMM YYYY HH:mm:ss");
        //     }
        // },
    },
    mounted() { },
    watch: {
        draw() {
            this.getData();
        },
    },
    computed: {
        setPage: {
            get() {
                return 1;
            },
            set(val) {
                this.handleChangePage(val);
            },
        },
        formatDate: () => {
            return (val) => {
                const momentDate = moment.utc(val);
                return momentDate.format('YYYY-MM-DD');
            };
        },
        // formatLocalNumber: () => {
        //     return (val) => {
        //         const formattedValue = parseInt(val).toLocaleString("id-ID", {
        //             style: "currency",
        //             currency: "IDR",
        //             minimumFractionDigits: 0,
        //             maximumFractionDigits: 0
        //         });
    
        //         const valueWithoutCurrencySymbol = formattedValue.replace(/[Rp\s]/g, '');
        //         return valueWithoutCurrencySymbol;
        //     }
        // },
    },
};
</script>

<style>
/* .d-inline-flex-b{
    display: inline-flex; 
    justify-content: space-between;
} */
</style>